




import { Component, Vue } from 'vue-property-decorator'
import PagedUserStories from './page/_page.vue'

@Component({
  components: {
    PagedUserStories,
  },
})
export default class UserStories extends Vue {}
